import React, { FC } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { IEventPersonEntity, IRecentAppointmentItem } from 'modules/booking/interfaces';
import { getArray } from 'common/utils/typeUtils';
import BookingPositionInQueue from 'components/Booking/BookingPositionInQueue';
import BookingAppointmentStatus from 'components/Booking/BookingAppointmentStatus';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'right',
  },
  waitList: {
    fontSize: '12px',
  },
}));

interface IBookingAppointmentInfo {
  appointment: IRecentAppointmentItem;
  userId: number;
}

const BookingAppointmentInfo: FC<IBookingAppointmentInfo> = ({ appointment, userId }) => {
  const classes = useStyles();
  const appointmentStatus = appointment.appointmentStatus;
  let appointmentInfo: JSX.Element | null = null;

  if (appointmentStatus) {
    appointmentInfo = (
      <Box className={classes.container}>
        <BookingAppointmentStatus appointmentStatus={appointmentStatus} />
      </Box>
    );
  } else {
    const persons = getArray<IEventPersonEntity>(appointment.persons);
    const person = persons.find(item => item.customer?.id === userId);

    if (person && person.waitList && person.waitListOrder) {
      appointmentInfo = (
        <Box className={classes.container}>
          <BookingPositionInQueue
            waitListOrder={person.waitListOrder}
            className={classes.waitList}
          />
        </Box>
      );
    }
  }

  return appointmentInfo;
};

export default BookingAppointmentInfo;
